import { useContext, useEffect } from "react";
import { LeaderboardContext } from "../../provider/leaderboard";
import "./index.scss";
import ThisWeekResult from "../ThisWeekResult";

const Termresult = () => {
  const {
    getWeekResult,
    leaderboardWeekTab,
    currentWeekResult,
    lastWeekLeaderboard,
    loadingTW,
    currentWeekEns,
  } = useContext(LeaderboardContext);

  const isLastWeek = leaderboardWeekTab === "last";
  const result = isLastWeek ? lastWeekLeaderboard : currentWeekResult;
  /* Last-week fetches are silent (no full-table loader when switching THIS/LAST week). */
  const loading = isLastWeek ? false : loadingTW;
  const weektype = isLastWeek ? "Previous" : "current";

  useEffect(() => {
    getWeekResult();
  }, []);

  return (
    <ThisWeekResult
      weektype={weektype}
      result={result}
      loading={loading}
      winner={currentWeekEns}
    />
  );
};

export default Termresult;
